export const REFUND_BY_SELLER_RADIO_LIST = [
  {
    id: 0,
    name: '전자상거래등에서의소비자보호에관한법률 등에 의한 제품의 하자 또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가 부담합니다.',
  },
  {
    id: 1,
    name: '상품상세 참조',
  },
  {
    id: 2,
    name: '직접입력',
  },
];

export const CANCEL_LIMIT_RADIO_LIST = [
  {
    id: 0,
    name: '전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에 준하는 것으로 인정되는 경우 청약철회가 제한될 수 있습니다.',
  },
  {
    id: 1,
    name: '상품상세 참조',
  },
  {
    id: 2,
    name: '직접입력',
  },
];

export const EXCHANGE_REFUND_GUARANTEE_RADIO_LIST = [
  {
    id: 0,
    name: '소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.',
  },
  {
    id: 1,
    name: '상품상세 참조',
  },
  {
    id: 2,
    name: '직접입력',
  },
];
export const DELIVERY_DELAY_RADIO_LIST = [
  {
    id: 0,
    name: '주문취소 및 대금의 환불은 amondz APP 을 통해 신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한 법률에 따라 소비자의 청약철회 후 판매자가 재화 등을 반환 받을 날로부터 ‘3’ 영업일 이내에 지급받은 대금의 환급을 정당한 사유 없이 지연하는 때에는 소비자는 지연기간에 대해서 연 20%의 지연배상금을 판매자에게 청구할 수 있습니다.',
  },
  {
    id: 1,
    name: '상품상세 참조',
  },
  {
    id: 2,
    name: '직접입력',
  },
];
export const CONSUMER_INJURY_RADIO_LIST = [
  {
    id: 0,
    name: '소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.',
  },
  {
    id: 1,
    name: '상품상세 참조',
  },
  {
    id: 2,
    name: '직접입력',
  },
];
export const TRADING_CONDITION_MAX_LENGTH = 500;
export const ORIGIN_ADDRESS_LINE2_MAX_LENGTH = 255;
export const RETURN_ADDRESS_LINE2_MAX_LENGTH = 255;
export const DELIVERY_INFORMATION_INFO_MAX_LENGTH = 500;
export const DELIVERY_CHARGE_JEJU_MAX_PRICE = 10000;
export const DELIVERY_CHARGE_JEJU_MAX_ETC = 10000;
export const AFTER_SERVICE_KAKAO_MAX_LENGTH = 30;
export const AFTER_SERVICE_INFO_MAX_LENGTH = 3000;
export const AFTER_SERVICE_CAUTION_MAX_LENGTH = 250;
export const AFTER_SERVICE_QUALITY_ASSURANCE_MAX_LENGTH = 250;
export const AFTER_SERVICE_MANUFACTURER_MAX_LENGTH = 50;
export const AFTER_SERVICE_ORIGIN_MAX_LENGTH = 15;
